import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'customDate',
})
export class CustomCheckoutDatePipe implements PipeTransform {
  transform(
    date: Date | string | undefined | null,
    type: 'date' | 'time' | 'both' = 'both'
  ): string | null {
    if (!date) return null;
    const momentDate = moment(date).tz('America/Santo_Domingo').locale('es');
    switch (type) {
      case 'date':
        return momentDate.format('dddd, D MMMM YYYY');
      case 'time':
        return momentDate.format('h:mm A');
      case 'both':
        return `${momentDate.format('dddd, D MMMM YYYY')}\n${momentDate.format(
          'h:mm A'
        )}`;
      default:
        return null;
    }
  }
}
